class Sidebar {

    constructor(el, options) {
        this.el = el;

        this.init();
    }

    init() {
        // Toggle the sidebar
        document.querySelectorAll('[data-toggle-sidebar]').forEach((el) => {
            el.addEventListener('click', function(e) {
                document.body.classList.toggle('-is-sidebar-visible');
            });
        });
    }
}

export { Sidebar as Sidebar };
